import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/util/storage.service';
import { OutletService } from '@core/services/outlet/outlet.service';
import { SessionStorageService } from '@core/services/util/session-storage.service';

import { StaticText } from '@project_app/config/static.text';
// declare var Notification: any;

declare global {
    interface Window {
        Notification: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class OutletStatusService {
    window: Window;
    staticText: any = StaticText;

    constructor(
        private storageService: StorageService,
        private sessionStorage: SessionStorageService,
        private outletService: OutletService
    ) {}

    getRemainingTime(data) {
        const sob_time = new Date(data.outlet.outlet_timings[0].sob_time) as any;
        const current_time = new Date() as any;
        return sob_time - current_time;
    }

    showWebNotification(icon, title, message) {
        const notificationTitle = title;
        const notificationOptions = {
            icon,
            body: message,
            requireInteraction: true
        };

        try {
            navigator.serviceWorker.getRegistration().then(function (registration) {
                if (registration && registration.active) {
                    registration.showNotification(notificationTitle, notificationOptions);
                }
            });
        } catch (e) {
            try {
                const web_notification = new Notification(notificationTitle, notificationOptions);
                web_notification.onclick = () => {
                    window.focus();
                    web_notification.close();
                };
            } catch (e) {
                throw new Error('Notification api is not supported.');
            }
            throw new Error('Service worker is not active.');
        }
    }

    onOutletStatusUpdate(outlet) {
        if (window.Notification) {
            if (Notification.permission === 'granted' && this.sessionStorage.get('previousOutletId') === outlet.id) {
                if (this.sessionStorage.get('IsOutletWasOpen') !== undefined) {
                    const msgContent = this.staticText.push_notification;
                    this.showWebNotification(msgContent.icon, msgContent.heading, msgContent.sub_heading);
                }
            }
            this.sessionStorage.remove('IsOutletWasOpen');
            this.sessionStorage.remove('previousOutletId');
        }
    }

    getOutletStatus(data, time) {
        setTimeout(() => {
            this.outletService.checkOutletStatus(data).then((response: any) => {
                if (response?.meta?.code === 200) {
                    this.onOutletStatusUpdate(response.outlet);
                } else {
                    this.scheduleOutletStatusCheck(data);
                }
            });
        }, time);
    }

    scheduleOutletStatusCheck(data) {
        if (data.meta.code === 201) {
            const remaining_time = this.getRemainingTime(data);
            if (remaining_time >= 0) {
                this.getOutletStatus(data, remaining_time);
            }

            this.sessionStorage.set('IsOutletWasOpen', false);
        } else if (data.meta.code === 202) {
            this.getOutletStatus(data, 300000);
            this.sessionStorage.set('IsOutletWasOpen', true);
        }
        this.sessionStorage.set('previousOutletId', data.outlet.id);
    }

    checkOutletStatus(data) {
        setTimeout(() => {
            if (data.outlet.dflt) {
                this.storageService.set('button_message', data.outlet.opens_at);
                const outletLocality = this.storageService.get('outlet_locality');

                if (!outletLocality || outletLocality === 'Showing Default Location' || outletLocality === '') {
                    this.storageService.set('outlet_locality', 'Showing Default Location');
                }
            } else if (!data.outlet.open) {
                if (data.outlet.active) {
                    this.scheduleOutletStatusCheck(data);
                }

                if (!data.outlet.preorder_available || !data.outlet.active) {
                    this.storageService.set('button_message', data.outlet.opens_at);
                }
            }
        });
    }
}
